const step1 = {
    label: 'Details',
    form: {
        type: 'form',
        children: [
            { key: 'name', type: 'form.text', label: 'Mission name', validate: { required: true } },
            {
                key: 'typeId',
                type: 'form.select',
                label: 'Mission type',
                valueProvider: { type: 'classifier.missionType' },
                validate: { required: true },
            },
            { key: 'description', type: 'form.text', label: 'Description', multiline: true, rows: 4 },
        ],
    },
    description: 'Tell your volunteers what this mission is all about',
};
const step2 = {
    label: 'Contact',
    form: {
        type: 'form',
        children: [
            { key: 'contactName', type: 'form.text', label: 'Name', validate: { required: true } },
            { key: 'contactEmail', type: 'form.email', label: 'Email' },
            { key: 'contactPhone', type: 'form.phone', label: 'Phone' },
        ],
    },
    description: 'Who is the main contact for this mission?',
};
export const missionWizardSteps = [step1, step2];
